import axios from "axios";
import appConfig from "config/app.config";

export const apiGet = async (endpoint, params = {}, callback) => {
  try {
    const response = await axios.get(endpoint, { params });
    if (response?.status === 200 && response?.data) {
      callback(response.data);
    }
  } catch (error) {
    console.error(`Error: Unable to fetch data from ${endpoint}`, error);
  }
}

export const getSlotGames = (callback, params = {}) => {
  const endpoint = `${appConfig.BASE_URL}/operator/1/game-details`
  const query = {
    gameCategory: "slot_game",
    ...params
  }

  apiGet(endpoint, query, data => {
    callback(data?.data)
  })
}

  export const getFastGames = (callback, params)=> {
    axios.get(`${appConfig.BASE_URL}/operator/1/game-details?gameCategory=fast_game&page=${params?.page}&perPage=${params?.perPage}`, {})
      .then((response) => {
        console.log('response: ', response);
        if (response?.status === 200 && response?.data) {
          callback(response?.data?.data);
        }
      }, (error) => {
        console.error('Error: Unable to get slot game')
      })
  }


  export const getCrashGames = (callback, params)=> {
    axios.get(`${appConfig.BASE_URL}/operator/1/game-details?gameCategory=crash_game&page=${params?.page}&perPage=${params?.perPage}`, {})
      .then((response) => {
        console.log('response: ', response);
        if (response?.status === 200 && response?.data) {
          callback(response?.data?.data);
        }
      }, (error) => {
        console.error('Error: Unable to get slot game')
      })
  }


  export const getGamesById = (callback, gameId)=> {
    axios.get(`${appConfig.BASE_URL}/operator/1/game-details?gameId=${gameId}`, {})
      .then((response) => {
        console.log('response: ', response);
        if (response?.status === 200 && response?.data) {
          callback(response?.data?.data);
        }
      }, (error) => {
        console.error('Error: Unable to get slot game')
      })
  }

  export const operatorLogin = (callback, body)=> {
    axios.post(`${appConfig.OPERATOR_BASE_URL}/auth/login`, body)
      .then((response) => {
        if (response?.status === 200 && response?.data) {
          callback(response?.data);
        }
      }, (error) => {
        console.error('Error: Unable to get slot game')
      })
  }

  export const submitContactUs = (callback, body)=> {
    axios.post(`${appConfig.BASE_URL}/system/contact-us`, body)
      .then((response) => {
        if (response?.status === 200 && response?.data) {
          callback(response?.data);
        }
      }, (error) => {
        console.error('Error: Unable to get slot game')
      })
  }